import script from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderNotificationsButton.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderNotificationsButton.vue?vue&type=style&index=0&id=2508dbd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2508dbd7"]])

export default __exports__